import { render, staticRenderFns } from "./GroupOverlay.vue?vue&type=template&id=54f20ce8&scoped=true&"
import script from "./GroupOverlay.vue?vue&type=script&lang=js&"
export * from "./GroupOverlay.vue?vue&type=script&lang=js&"
import style0 from "./GroupOverlay.vue?vue&type=style&index=0&id=54f20ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f20ce8",
  null
  
)

export default component.exports